import { render, staticRenderFns } from "./EditUserBusinessPermissionGroup.vue?vue&type=template&id=1b37c99e&scoped=true&"
import script from "./EditUserBusinessPermissionGroup.ts?vue&type=script&lang=ts&"
export * from "./EditUserBusinessPermissionGroup.ts?vue&type=script&lang=ts&"
import style0 from "./EditUserBusinessPermissionGroup.vue?vue&type=style&index=0&id=1b37c99e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b37c99e",
  null
  
)

export default component.exports